import { fetchAction, fetchApi, fetchPostApi } from "../../../helpers/fetch";

export const getAccountSession = (accountId) => fetchPostApi(`/api/accounts/session/${accountId}`)
export const refreshCapabilities = () => fetchPostApi("/api/accounts/refresh-capabilities", {})
export const completeOnboarding = (payload) => fetchPostApi("/api/accounts/onboard", payload)

export const createPayout = (amount, bankAccountId) => fetchPostApi(`/api/accounts/payout`, { amount, bankAccountId });

export const getPaginatedPayouts = (limit) =>
    fetchAction(`/api/accounts/payout?limit=${limit}`, [
        "GET_PAYOUTS_REQUEST",
        "GET_PAYOUTS_SUCCESS",
        "GET_PAYOUTS_FAILURE",
    ]);

export const getOauthLink = () => fetchAction("/api/accounts/oauth/link", [
    "GET_OAUTH_LINK_REQUEST",
    "GET_OAUTH_LINK_SUCCESS",
    "GET_OAUTH_LINK_FAILURE",
])

export const getIsUserOAuthorized = () => fetchAction("/api/accounts/oauth-status", [
    "GET_OAUTH_STATUS_REQUEST",
    "GET_OAUTH_STATUS_SUCCESS",
    "GET_OAUTH_STATUS_FAILURE",
])

export const getEarnings = () => fetchAction("/api/accounts/earnings", [
    "GET_EARNINGS_REQUEST",
    "GET_EARNINGS_SUCCESS",
    "GET_EARNINGS_FAILURE",
])

export const getAccount = () => fetchAction("/api/accounts", [
    "GET_ACCOUNT_REQUEST",
    "GET_ACCOUNT_SUCCESS",
    "GET_ACCOUNT_FAILURE",
])

export const getAccountOnboardingLink = (accountId, options = {}) => {
    const params = new URLSearchParams();
    if (options?.fullKyc) {
        params.set("fullKyc", "1");
    }
    if (options?.fields) {
        params.set("fields", options.fields);
    }
    const query = params.toString();
    const endpoint = `/api/accounts/link/${accountId}${query ? `?${query}` : ""}`;
    return fetchApi(endpoint);
}
export const getKycStatus = () => fetchApi("/api/accounts/kyc-status")

// Stripe-supported Connect countries, sourced from the backend (which reads
// Stripe's country specs). [{ code, service_agreement }]
export const getConnectCountries = () => fetchApi("/api/accounts/connect-countries")

export const getBalance = () => fetchAction(`/api/accounts/balance`, [
    "GET_BALANCE_REQUEST",
    "GET_BALANCE_SUCCESS",
    "GET_BALANCE_FAILURE",
]);

export const getBankAccount = () => fetchAction(`/api/accounts/bank-account`, [
    "GET_BANK_ACCOUNT_REQUEST",
    "GET_BANK_ACCOUNT_SUCCESS",
    "GET_BANK_ACCOUNT_FAILURE",
])

/** Creator analytics: stats, earnings timeline, paid vs free creations */
export const getCreatorAnalytics = () => fetchApi('/api/accounts/analytics')
